<h2 mat-dialog-title>{{ 'Select_files_to_unpack_tr' | translate }}</h2>
@if (queueTotal && queueTotal > 1) {
  <div class="queue-progress" role="status" aria-live="polite">
    {{ 'Reviewing_file_progress_tr' | translate:{ position: queuePosition, total: queueTotal } }}
    · {{ data.file.name }}
  </div>
}
<mat-dialog-content class="zip-explorer">
  @if (error()) {
    <p class="error">{{ error() }}</p>
  } @else if (loading()) {
    <p>{{ 'Loading_ZIP_tr' | translate }}</p>
  } @else if (!entries().length) {
    <p>{{ 'No_supported_files_found_inside_the_archive_tr' | translate }}</p>
  } @else {
    <div class="tree-actions">
      <button type="button" mat-stroked-button (click)="toggleAll(true)">{{ 'Select_All_tr' | translate }}</button>
      <button type="button" mat-stroked-button (click)="toggleAll(false)">{{ 'Clear_tr' | translate }}</button>
    </div>
    <div class="tree-header">
      <span class="name-col">{{ 'Name_tr' | translate }}</span>
      <span class="size-col">{{ 'Size_tr' | translate }}</span>
      <span class="title-col">{{ 'Title_tr' | translate }}</span>
      <span class="type-col">{{ 'Document_Type_tr' | translate }} *</span>
      <span class="preview-col">{{ 'Preview_tr' | translate }}</span>
    </div>
    <div class="tree-container">
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { nodes: tree(), level: 0 }"></ng-container>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button type="button" mat-button (click)="dialogRef.close()">{{ 'cancel_tr' | translate }}</button>
  <button
    type="button"
    mat-raised-button
    color="primary"
    data-testid="unpack-selected-button"
    [disabled]="readOnly() || !hasSelection() || !canImportSelected()"
    (click)="importSelected()"
  >
    <span [matTooltip]="'Unpack_selected_files_upload_hint_tr' | translate">
      {{ (queueTotal && queueTotal > 1 ? 'Unpack_selected_and_continue_tr' : 'Unpack_Selected_tr') | translate }}
    </span>
  </button>
</mat-dialog-actions>
<ng-template #nodeTemplate let-nodes="nodes" let-level="level">
  <ng-container *ngFor="let node of nodes; trackBy: trackNode">
    <div class="tree-row" [class.directory]="node.isDirectory">
      <div class="name-cell" [style.padding-left.px]="level * 16">
        @if (node.isDirectory) {
          <button type="button" class="toggle-btn" (click)="toggleDirectory(node.path)">
            <mat-icon>
              {{ isExpanded(node.path) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
        } @else {
          <span class="toggle-placeholder"></span>
        }
        <mat-icon class="type-icon">
          {{ node.isDirectory ? 'folder' : 'insert_drive_file' }}
        </mat-icon>
        @if (!node.isDirectory) {
          <mat-checkbox [(ngModel)]="node.entry!.selected" [ngModelOptions]="{ standalone: true }"></mat-checkbox>
        } @else {
          <span class="folder-padding"></span>
        }
        <div class="entry-details">
          <div class="entry-name">{{ node.name }}</div>
        </div>
      </div>
      <div class="size-cell" [attr.data-label]="'Size_tr' | translate">{{ formatBytes(node.size) }}</div>
      <div class="title-cell" [attr.data-label]="'Title_tr' | translate">
        @if (!node.isDirectory) {
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="node.entry!.title" [ngModelOptions]="{ standalone: true }" />
          </mat-form-field>
        } @else {
          <span class="placeholder">--</span>
        }
      </div>
      <div class="type-cell" [attr.data-label]="'Document_Type_tr' | translate">
        @if (!node.isDirectory) {
          <mat-form-field appearance="outline">
            <mat-select
              [ngModel]="node.entry!.documentTypeId"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onDocumentTypeChange(node.entry!, $event)"
              [disabled]="typesLoading()"
              required
              [placeholder]="'Select_tr' | translate"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="typeSearchControl"
                  [placeholderLabel]="'Search_document_types_tr' | translate"
                  [noEntriesFoundLabel]="'No_document_types_found_tr' | translate"
                  [disabled]="typesLoading()"
                ></ngx-mat-select-search>
              </mat-option>
              @for (group of typeGroups(); track group.category) {
                <mat-optgroup>
                  <div class="group-label">
                    <span>
                      <b>{{ group.labelKey | translate }}</b>
                    </span>
                  </div>
                  @for (type of group.types; track type.id) {
                    <mat-option [value]="type.id">{{ type.name }}</mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>
        } @else {
          <span class="placeholder">--</span>
        }
      </div>
      <div class="preview-cell" [attr.data-label]="'Preview_tr' | translate">
        @if (!node.isDirectory) {
          <div class="preview-thumb-wrap">
            <button type="button" class="preview-thumb-button" (click)="previewEntry(node); $event.stopPropagation()">
              @if (previewSrc(node); as src) {
                <img [src]="src" [alt]="node.name" />
              } @else {
                <mat-icon>insert_drive_file</mat-icon>
              }
            </button>
            <button type="button" class="preview-hover-button" (click)="previewEntry(node); $event.stopPropagation()">
              <mat-icon>visibility</mat-icon>
              <span>{{ 'Preview_tr' | translate }}</span>
            </button>
          </div>
        } @else {
          <span class="placeholder">--</span>
        }
      </div>
    </div>
    @if (node.isDirectory && isExpanded(node.path)) {
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { nodes: node.children, level: level + 1 }"></ng-container>
    }
  </ng-container>
</ng-template>
